import React, { useState } from "react";
import { Button, Typography, FormControl, Grid } from "@mui/material";
import ViewIcon from "../../assets/Icon/ViewIcon.png";
import DownLoadIcon from "../../assets/Icon/DownLoadIcon.png";
import UploadIcon from "../../assets/Icon/UploadIcon.png";
import { SERVER_BASE_ADDRESS } from "../../globals/const";

const FileUpload = ({
  label,
  onChange,
  name,
  accept,
  error,
  helperText,
  edit,
  fileData,
  documentId,
  disabled, // New prop to indicate whether the component is disabled
  documentText,
  hideSubtext,
}) => {
  const [fileName, setFileName] = useState("");
  const uploadInputName = `${name}`;
  const [blobUrl, setBlobUrl] = useState(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file.name);
    onChange(event);
  };

  const downloadDocument = (documentId) => {
    window.open(
      `${SERVER_BASE_ADDRESS}/fpo/download_file/?identifier=${documentId}&file_type=${name}`
    );
  };

  const handleViewFile = () => {
    if (fileName) {
      setBlobUrl(URL.createObjectURL(fileData));
    }
  };

  return (
    <FormControl
      fullWidth
      error={error}
      style={{
        display: "flex",
        flexDirection: "row",
        marginTop: "20px",
      }}
    >
      {" "}
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <div>
            <Typography>
              {label.charAt(0).toUpperCase() +
                label.slice(1).toLowerCase() +
                " "}
              {documentText && documentText}
            </Typography>
            {!hideSubtext && (
              <Typography style={{ fontSize: "10px", fontWeight: 500 }}>
                (pdf, jpeg, heic, png file Only)
              </Typography>
            )}
            {!fileName && fileData && (
              <Typography style={{ fontSize: "12px", marginTop: "10px" }}>
                {fileData.split("/").pop().split("?")[0]}
              </Typography>
            )}

            {fileName && (
              <Typography style={{ fontSize: "12px", marginTop: "10px" }}>
                {fileName}
              </Typography>
            )}
            {error && (
              <Typography style={{ color: "red", fontSize: "12px" }}>
                {helperText}
              </Typography>
            )}
          </div>
        </Grid>

        {!disabled && (
          <Grid item={4}>
            <input
              type="file"
              name={name}
              accept={accept}
              onChange={handleFileChange}
              style={{ display: "none" }}
              id={name}
            />
            <Button
              variant="contained"
              component="label"
              style={{
                marginLeft: "auto",
                color: "white",
                width: "152px",
                height: "40px",
              }}
              htmlFor={name}
            >
              Upload
            </Button>
          </Grid>
        )}

        {edit && (
          <>
            <Grid item xs={1} marginLeft={2}>
              <label htmlFor={uploadInputName}>
                <img
                  src={UploadIcon}
                  alt="Upload"
                  style={{ cursor: "pointer" }}
                />
              </label>
              <input
                id={uploadInputName}
                type="file"
                name={uploadInputName}
                accept={accept}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Grid>
            <Grid item xs={1} marginLeft={2}>
              {fileName ? (
                <a
                  href={blobUrl}
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleViewFile}
                >
                  <img src={ViewIcon} alt="View" />
                </a>
              ) : (
                <a href={fileData} target="_blank" rel="noreferrer">
                  <img src={ViewIcon} />
                </a>
              )}
            </Grid>
            <Grid
              item
              xs={1}
              marginLeft={2}
              style={{
                opacity: fileName ? 0.5 : 1,
                pointerEvents: fileName ? "none" : "auto",
              }}
            >
              <img
                src={DownLoadIcon}
                alt="Download"
                onClick={() => downloadDocument(documentId)}
              />
            </Grid>
          </>
        )}
      </Grid>
    </FormControl>
  );
};

export default FileUpload;
